<template>
  <div class="intro-ct">
    <div class="description-ct">
      <div>
        <p class="headline-paragraph">
          {{ $t('InfinityAI_Intro_Title') }}
        </p>
      </div>
      <div>
        <p class="sub-paragraph">
          {{ $t('InfinityAI_Intro_Description') }}
        </p>
      </div>
      <div>
        <el-button @click="onBtnClick()" type="primary">
          {{ $t('InfinityAI_Intro_Btn') }}
        </el-button>
      </div>
    </div>
    <div>
      <img src="@/img/mlstudio/intro.svg" :alt="$t('InfinityAI_Intro_Title')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MLStudioUpsellIntroduction',

  methods: {
    onBtnClick() {
      this.$emit('request-demo')
    }
  }
}
</script>

<style scoped>
.intro-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 22px;
  padding: 60px 65px;
  background-color: #fff;
}

img {
  width: 505px;
  height: 353px;
  object-fit: contain;
}

.description-ct {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 500px;
}

.headline-paragraph {
  color: #176ca1;
  font-size: 32px;
  font-weight: 600;
  line-height: 42px;
}

.sub-paragraph {
  color: #7e8596;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-wrap: balance;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/components/MlStudioUpsellIntroduction.vue